import { render } from "./Textarea.vue?vue&type=template&id=e23d7a1e&scoped=true&ts=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"

import "./textarea.scss?vue&type=style&index=0&id=e23d7a1e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23d7a1e"]])

export default __exports__